<template>
  <div class="comment-container">
    <div class="comment-text text-sm grey-900">
      {{ comment.text }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Comment',
    props: {
      comment: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .comment-container {
    background: $primary50;
    border-radius: 8px;
    padding: 8px;
  }
</style>
